/**
 * How a customer receives an eCommerce order, as offered at checkout. Carts and orders store the choice as
 * the is_local_pickup / is_local_delivery flags (both false = shipping); these values are what
 * Suppliers.settings.screens.eCommerce.fulfillmentOptions lists. The values double as translation keys.
 */
enum EcommerceFulfillmentEnum {
    SHIPPING = "shipping",
    LOCAL_PICKUP = "local_pickup",
    LOCAL_DELIVERY = "local_delivery",
}

export default EcommerceFulfillmentEnum;
